export default "__VITE_ASSET__j8eJhN$J__"